export default __webpack_public_path__ + "locales/az/Payments.json?hash=1d6289e60a31e34e018267e232a920d9";